import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { VersionService } from '../../../core/services/version.service';

@Component({
  selector: 'app-version-mismatch-modal',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  templateUrl: './version-mismatch-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionMismatchModalComponent {
  readonly versionService = inject(VersionService);

  refresh(): void {
    window.location.reload();
  }
}
